import { IStepProps } from '../../components/stepByStep/types'
import {
  KEY_SETUP_COMPANY,
  KEY_SETUP_CREDENTIALS,
  KEY_SETUP_CREDENTIALS_CONCLUSION,
  KEY_SETUP_SYSTEM,
  KEY_SETUP_SYSTEM_CONFIG,
  KEY_SETUP_SYSTEM_CUSTOM_THEME,
  KEY_SETUP_SYSTEM_THEME,
  KEY_SETUP_USER,
} from '../../utils/constants'

export const STEPS: IStepProps[] = [
  {
    title: 'Dados Iniciais',
    active: true,
    id: KEY_SETUP_USER,
    completed: false,
    parent: null,
  },
  {
    title: 'Empresa',
    active: false,
    id: KEY_SETUP_COMPANY,
    completed: false,
    parent: null,
  },
  {
    title: 'Sistema',
    active: false,
    id: KEY_SETUP_SYSTEM,
    completed: false,
    parent: null,
  },
  {
    title: 'Credenciais',
    active: false,
    id: KEY_SETUP_CREDENTIALS,
    completed: false,
    parent: null,
  },
  {
    title: 'system_config',
    active: false,
    id: KEY_SETUP_SYSTEM_CONFIG,
    completed: false,
    parent: KEY_SETUP_SYSTEM,
  },
  {
    title: 'system_theme',
    active: false,
    id: KEY_SETUP_SYSTEM_THEME,
    completed: false,
    parent: KEY_SETUP_SYSTEM,
  },
  {
    title: 'system_custom_theme',
    active: false,
    id: KEY_SETUP_SYSTEM_CUSTOM_THEME,
    completed: false,
    parent: KEY_SETUP_SYSTEM,
  },
  {
    title: 'credentials_conclusion',
    active: false,
    id: KEY_SETUP_CREDENTIALS_CONCLUSION,
    completed: false,
    parent: KEY_SETUP_CREDENTIALS,
  },
]

export const KEYS_TO_PREVIOUS: Record<number, number> = {
  [KEY_SETUP_COMPANY]: KEY_SETUP_USER,
  [KEY_SETUP_SYSTEM_CONFIG]: KEY_SETUP_COMPANY,
  [KEY_SETUP_SYSTEM_THEME]: KEY_SETUP_SYSTEM_CONFIG,
  [KEY_SETUP_SYSTEM_CUSTOM_THEME]: KEY_SETUP_SYSTEM_THEME,
  [KEY_SETUP_CREDENTIALS]: KEY_SETUP_SYSTEM_CUSTOM_THEME,
  [KEY_SETUP_CREDENTIALS_CONCLUSION]: KEY_SETUP_CREDENTIALS,
}

export const KEYS_TO_NEXT: Record<number, number> = {
  [KEY_SETUP_USER]: KEY_SETUP_COMPANY,
  [KEY_SETUP_COMPANY]: KEY_SETUP_SYSTEM_CONFIG,
  [KEY_SETUP_SYSTEM_CONFIG]: KEY_SETUP_SYSTEM_THEME,
  [KEY_SETUP_SYSTEM_THEME]: KEY_SETUP_SYSTEM_CUSTOM_THEME,
  [KEY_SETUP_SYSTEM_CUSTOM_THEME]: KEY_SETUP_CREDENTIALS,
  [KEY_SETUP_CREDENTIALS]: KEY_SETUP_CREDENTIALS_CONCLUSION,
}
